import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { editDeleteStyles } from "../../../globals";
import Modal from "../../Modal/Modal";
import STSComponent from "../../STSComponent/STSComponent";

class EditItem extends STSComponent {
  render() {
    const {
      modalType,
      title,
      toSave,
      toCancel,
      content,
      customStyles,
      saveButton,
      titleArea,
      additionalBtn,
      modal,
      savingNotAvailable,
      zIndex,
    } = this.props;

    return (
      <Modal
        modalType={`Edit-item-${modalType}`}
        contentLabel={`Edit-item-${modalType}`}
        customStyles={editDeleteStyles[customStyles] || editDeleteStyles.edit}
        modal={modal}
        zIndex={ zIndex ? zIndex : 97 }
      >
        <div className="get-report-modals-titlearea flex-wrap">
          {title ? (
            <span className="get-report-modals-title">Edit {title}</span>
          ) : (
            <Fragment>
              <span className="get-report-modals-title">{titleArea.title}</span>
              {titleArea.node}
            </Fragment>
          )}
        </div>
        {content}
        <div className="get-report-modals-buttons-area buttonsarea-type2">
          <button disabled={savingNotAvailable} onClick={toSave}>
            {saveButton}
          </button>
          {additionalBtn}
          <button onClick={toCancel}>Cancel</button>
        </div>
      </Modal>
    );
  }

  static propTypes = {
    modalType: PropTypes.string,
    title: PropTypes.string,
    toCancel: PropTypes.func,
    toSave: PropTypes.func,
    content: PropTypes.node,
    customStyles: PropTypes.string,
    saveButton: PropTypes.string,
    titleArea: PropTypes.object,
    additionalBtn: PropTypes.node,
    modal: PropTypes.object,
    savingNotAvailable: PropTypes.bool,
  };
}

export default EditItem;



// WEBPACK FOOTER //
// ./src/components/Modal/components/EditItem.js